import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { LogoLoading } from "../components/common/utlity/utility";
import SeoPageNotFound from "../pages/seoPageNotFound";
import {checkSubdomainByBusiness, resolveDomain} from "../services/seo.service"

const SubdomainChecker = ({ children }) => {
  const [status, setStatus] = useState("loading"); 
const [seo, setSeo] = useState(null);

useEffect(() => {
  const checkDomain = async () => {
    try {
      const hostname = window.location.hostname;
      if (hostname.includes("localhost")) {
        setStatus("active");
        return;
      }
      if (hostname === "app.dukanbuddy.com") {
        setStatus("active");
        return;
      }

      let subdomain = null;

      if (hostname.endsWith(".app.dukanbuddy.com")) {
        subdomain = hostname.replace(".app.dukanbuddy.com", "");
      }

      if (!subdomain) {
        // Fallback for custom domains
        const response = await resolveDomain(hostname);
        if (response?.data?.success) {
          setSeo(response.data.data);
          setStatus("active");
        } else {
          setStatus("inactive");
        }
        return;
      }

      const response = await checkSubdomainByBusiness(subdomain);

      if (response?.status === 200) {
        setSeo(response.data.data);
        setStatus("active");
      } else {
        setStatus("inactive");
      }

    } catch (error) {
      console.error("Subdomain validation failed:", error);
      setStatus("inactive");
    }
  };

  checkDomain();
}, []);
  if (status === "loading") {
    return <LogoLoading />;
  }
  if (status === "inactive") {
    return <SeoPageNotFound />;
  }

return (
  <>
    {seo && (
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta property="og:title" content={seo.title} />

        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />

      </Helmet>
    )}
    {children}
  </>
);
};

export default SubdomainChecker;